module.exports = __webpack_public_path__ + "static/media/money_bonus_4.058afab3.webp";